import styled from "styled-components";

export const FormGroup = styled.div`
  margin: 2rem 0;
`;

export const SignInActionsContainer = styled('div', {
  shouldForwardProp: (prop) => !['gap'].includes(prop),
})(({ gap = 'large' }) => `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${gap === 'large' ? '0.75rem' : '0.25rem'};
  margin: 1.5rem 0 0.5rem;
  align-items: center;

  .svg-inline--fa {
    margin-right: 0.5rem;
  }
`);

export const GoogleButtonWrapper = styled.div`
  min-height: 40px;
  width: 100%;
`;

export const SigninForm = styled.form`
  ${({ theme }) => `
    .btn {
      ${theme.breakpoints.down('xs')} {
        display: block;
        width: 100%;
      }
    }

    ${SignInActionsContainer} .btn,
    ${SignInActionsContainer} ${GoogleButtonWrapper} {
      align-items: center;
      display: inline-flex;
      justify-content: center;
      margin: 0;
      width: auto;
    }
  `}
`;
